import React from 'react';
import { Link } from 'react-router-dom';
import BenevitaLogo from '../../components/BenevitaLogo';

const C = {
  navy: '#2b1b22', muted: '#8b7681', border: '#ece3e7', primary: '#7b1e3c',
};

function OptionCard({ to, title, subtitle, primary }) {
  return (
    <Link to={to} style={{
      display: 'block', padding: '18px 20px', borderRadius: 12,
      textDecoration: 'none', marginBottom: 14,
      background: primary ? 'linear-gradient(180deg,#94335a,#7b1e3c)' : '#fff',
      border: `1px solid ${primary ? 'transparent' : C.border}`,
      boxShadow: primary
        ? '0 8px 20px -6px rgba(123,30,60,0.35)'
        : '0 1px 2px rgba(13,27,46,0.04)',
    }}>
      <div style={{
        fontSize: 15, fontWeight: 800,
        color: primary ? '#fff' : C.navy, marginBottom: 4,
      }}>{title}</div>
      <div style={{
        fontSize: 12.5, lineHeight: 1.5,
        color: primary ? 'rgba(255,255,255,0.85)' : C.muted,
      }}>{subtitle}</div>
    </Link>
  );
}

export default function RequestCareGate() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f4f6fa', fontFamily: 'Inter, sans-serif', padding: '40px 16px',
    }}>
      <div style={{
        width: '100%', maxWidth: 460, background: '#fff', borderRadius: 16,
        padding: '38px 36px', border: '1px solid #ece3e7',
        boxShadow: '0 1px 2px rgba(13,27,46,0.04), 0 12px 32px -8px rgba(13,27,46,0.08)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 22 }}>
          <BenevitaLogo size={38} variant="mark" />
          <div style={{ fontFamily: 'Georgia, serif', fontSize: 17, fontWeight: 400, color: C.navy }}>benevita</div>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 800, color: C.navy, margin: '0 0 6px' }}>
          Request care
        </h1>
        <p style={{ fontSize: 13, color: C.muted, lineHeight: 1.6, margin: '0 0 24px' }}>
          Care requests are submitted from your account, so our team can track,
          triage, and follow up with you directly.
        </p>

        <OptionCard
          to="/signup"
          primary
          title="I don't have an account"
          subtitle="Create a free patient account — takes about a minute, verified by a quick email code."
        />
        <OptionCard
          to="/login"
          title="I already have an account"
          subtitle="Sign in and submit your care request from your dashboard."
        />

        <p style={{ textAlign: 'center', fontSize: 12, color: C.muted, marginTop: 20, marginBottom: 0 }}>
          Just have a question first?{' '}
          <Link to="/contact" style={{ color: C.primary, fontWeight: 700, textDecoration: 'none' }}>
            Contact us instead
          </Link>
        </p>
      </div>
    </div>
  );
}
